/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./LoyaltyButton.vue?vue&type=template&id=3639a858"
import script from "./LoyaltyButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoyaltyButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LoyaltyButton.vue?vue&type=style&index=0&id=3639a858&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports